/** Top layer — above modals and typical overlays. */
export const POPOVER_Z = 2147483647
export const DEFAULT_HIDE_MS = 200
export const DEFAULT_MAX_WIDTH = 448
export const MAX_HEIGHT_VH_RATIO = 0.45
export const MAX_HEIGHT_CAP = 360
export const TRIGGER_GAP = 6
export const VIEWPORT_INSET = 8
